import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import ColorPickerInput from "../../common/ColorPicker";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [headerColor, setHeaderColor] = useState("");
  const [footerColor, setFooterColor] = useState("");

  const GetEditData = async () => {
    const response = await getData(`/home/app-setup/${id}`);
    reset(response?.data);
    setHeaderColor(response?.data?.header_color);
    setFooterColor(response?.data?.footer_color);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
    reset,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const finalData = new FormData();
      finalData.append("name", data?.name);
      finalData.append("contact_no", data?.contact_no);
      finalData.append("address", data?.address);
      finalData.append("email", data?.email);
      finalData.append("app_version", data?.app_version);
      // finalData.append("coin_number", data?.coin_number);
      finalData.append("premium_status", data?.premium_status);
      finalData.append("premium_user_delay", data?.premium_user_delay);
      finalData.append("not_premium_user_delay", data?.not_premium_user_delay);
      // finalData.append("average_kilometer", data?.average_kilometer);
      // finalData.append("minimum_kilometer", data?.minimum_kilometer);
      // finalData.append("mid_kilometer", data?.mid_kilometer);
      // finalData.append("platform_percentage", data?.platform_percentage);
      // finalData.append("gst_percentage", data?.gst_percentage);
      // finalData.append("discount_percentage", data?.discount_percentage);
      // finalData.append("cod_percentage", data?.cod_percentage);
      // finalData.append("image", data?.image[0]);
      const response = await postData(`/home/app-setup/${id}`, finalData);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit App SetUp
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>App Version</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="App Version"
                          className={classNames("", {
                            "is-invalid": errors?.app_version,
                          })}
                          {...register("app_version", {
                            required: "App Version is required",
                          })}
                        />
                      </InputGroup>
                      {errors.app_version && (
                        <span className="text-danger">
                          {errors.app_version.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Name</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Banner"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Name is required",
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Contact No.</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="contact_no"
                          placeholder="Contact No"
                          className={classNames("", {
                            "is-invalid": errors?.contact_no,
                          })}
                          {...register("contact_no", {
                            required: "Contact No is required",
                            validate: (value) =>
                              value.length === 10 ||
                              " Contact number must be exactly 10 digits",
                          })}
                          onKeyDown={(event) => {
                            const { key } = event;
                            const value = event.target.value;

                            // Prevent non-digit characters except Backspace and Tab
                            if (
                              !/[0-9]/.test(key) &&
                              key !== "Backspace" &&
                              key !== "Tab"
                            ) {
                              event.preventDefault();
                            }

                            // Prevent input if length exceeds 10 digits
                            if (
                              value?.length >= 10 &&
                              key !== "Backspace" &&
                              key !== "Tab"
                            ) {
                              event.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.contact_no && (
                        <span className="text-danger">
                          {errors.contact_no.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Address</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="address"
                          placeholder="Address"
                          className={classNames("", {
                            "is-invalid": errors?.address,
                          })}
                          {...register("address", {
                            required: "Address is required",
                          })}
                        />
                      </InputGroup>
                      {errors.address && (
                        <span className="text-danger">
                          {errors.address.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Email</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="email"
                          placeholder="Email"
                          className={classNames("", {
                            "is-invalid": errors?.email,
                          })}
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value:
                                /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
                              message: "Invalid Email address",
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.email && (
                        <span className="text-danger">
                          {errors.email.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Premium Status</Form.Label>
                    <Form.Group controlId="confirmAddress" className="mt-3">
                      <Form.Check
                        type="checkbox"
                        label="Premium Status"
                        {...register("premium_status", {
                          // required: "Please confirm the address",
                        })}
                        // isInvalid={!!errors.confirmAddress}
                      />
                      {/* {errors.premium_status && (
          <span className="text-danger">
            {errors.confirmAddress.message}
          </span>
        )} */}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Premium User Delay</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="booking_count"
                          placeholder="Premium User Delay"
                          className={classNames("", {
                            "is-invalid": errors?.premium_user_delay,
                          })}
                          {...register("premium_user_delay", {
                            required: "Premium User Delay is required",
                            min: {
                              value: 0,
                              message:
                                "Premium User Delay cannot be less than 0",
                            },
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.premium_user_delay && (
                        <span className="text-danger">
                          {errors.premium_user_delay.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Not Premium User Delay</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="booking_count"
                          placeholder="Not Premium User Delay"
                          className={classNames("", {
                            "is-invalid": errors?.not_premium_user_delay,
                          })}
                          {...register("not_premium_user_delay", {
                            required: "Not Premium User Delay is required",
                            min: {
                              value: 0,
                              message:
                                "Not Premium User Delay cannot be less than 0",
                            },
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.not_premium_user_delay && (
                        <span className="text-danger">
                          {errors.not_premium_user_delay.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Reward Point</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="booking_count"
                          placeholder="Platform Percent"
                          className={classNames("", {
                            "is-invalid": errors?.booking_count,
                          })}
                          {...register("booking_count", {
                            required: "Reward Point is required",
                            min: {
                              value: 0,
                              message: "Reward Point cannot be less than 0",
                            },
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.booking_count && (
                        <span className="text-danger">
                          {errors.booking_count.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Price Per Reward Point</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="coin_number"
                          placeholder="Platform Percent"
                          className={classNames("", {
                            "is-invalid": errors?.coin_number,
                          })}
                          {...register("coin_number", {
                            required: "Price Per Reward Point is required",
                            min: {
                              value: 0,
                              message: "Reward Point cannot be less than 0",
                            },
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.coin_number && (
                        <span className="text-danger">
                          {errors.coin_number.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Average Kilometer</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="platform_charges"
                          placeholder="Average Kilometer"
                          className={classNames("", {
                            "is-invalid": errors?.average_kilometer,
                          })}
                          {...register("average_kilometer", {
                            required: "Average Kilometer are required",
                            // min: {
                            //   value: 0,
                            //   message: "Platform Percent cannot be less than 0",
                            // },
                            // max: {
                            //   value: 100,
                            //   message: "Platform Percent cannot exceed 100",
                            // },
                          })}
                        />
                      </InputGroup>
                      {errors.average_kilometer && (
                        <span className="text-danger">
                          {errors.average_kilometer.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Minimun Kilometer</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="minimum_kilometer"
                          placeholder="Minimun Kilometer"
                          className={classNames("", {
                            "is-invalid": errors?.minimum_kilometer,
                          })}
                          {...register("minimum_kilometer", {
                            required: "Minimun Kilometer are required",
                            // min: {
                            //   value: 0,
                            //   message: "Platform Percent cannot be less than 0",
                            // },
                            // max: {
                            //   value: 100,
                            //   message: "Platform Percent cannot exceed 100",
                            // },
                          })}
                        />
                      </InputGroup>
                      {errors.minimum_kilometer && (
                        <span className="text-danger">
                          {errors.minimum_kilometer.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Mid Kilometer</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="mid_kilometer"
                          placeholder="Mid Kilometer"
                          className={classNames("", {
                            "is-invalid": errors?.mid_kilometer,
                          })}
                          {...register("mid_kilometer", {
                            required: "Mid Kilometer are required",
                            // min: {
                            //   value: 0,
                            //   message: "Platform Percent cannot be less than 0",
                            // },
                            // max: {
                            //   value: 100,
                            //   message: "Platform Percent cannot exceed 100",
                            // },
                          })}
                        />
                      </InputGroup>
                      {errors.mid_kilometer && (
                        <span className="text-danger">
                          {errors.mid_kilometer.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Platform Percentage</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="platform_percentage"
                          placeholder="Platform Percent"
                          className={classNames("", {
                            "is-invalid": errors?.platform_percentage,
                          })}
                          {...register("platform_percentage", {
                            required: "Platform Percent is required",
                            min: {
                              value: 0,
                              message: "Platform Percent cannot be less than 0",
                            },
                            max: {
                              value: 100,
                              message: "Platform Percent cannot exceed 100",
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.platform_percentage && (
                        <span className="text-danger">
                          {errors.platform_percentage.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>GST Percentage</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="gst_percentage"
                          placeholder="GST Percent"
                          className={classNames("", {
                            "is-invalid": errors?.gst_percentage,
                          })}
                          {...register("gst_percentage", {
                            required: "GST Percent is required",
                            min: {
                              value: 0,
                              message: "GST Percent cannot be less than 0",
                            },
                            max: {
                              value: 100,
                              message: "GST Percent cannot exceed 100",
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.gst_percentage && (
                        <span className="text-danger">
                          {errors.gst_percentage.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>COD Percentage</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="cod_percentage"
                          placeholder="COD Percent"
                          className={classNames("", {
                            "is-invalid": errors?.cod_percentage,
                          })}
                          {...register("cod_percentage", {
                            required: "COD Percent is required",
                            min: {
                              value: 0,
                              message: "COD Percent cannot be less than 0",
                            },
                            max: {
                              value: 100,
                              message: "COD Percent cannot exceed 100",
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.cod_percentage && (
                        <span className="text-danger">
                          {errors.cod_percentage.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Discount Percentage</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="discount_percentage"
                          placeholder="Discount Percent"
                          className={classNames("", {
                            "is-invalid": errors?.discount_percentage,
                          })}
                          {...register("discount_percentage", {
                            required: "Discount Percent is required",
                            min: {
                              value: 0,
                              message: "Discount Percent cannot be less than 0",
                            },
                            max: {
                              value: 100,
                              message: "Discount Percent cannot exceed 100",
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.discount_percentage && (
                        <span className="text-danger">
                          {errors.discount_percentage.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Header Color</Form.Label>
                    <Form.Group>
                      <ColorPickerInput
                        value={headerColor}
                        onChange={(color) => setHeaderColor(color)}
                        errors={errors} // Pass errors to the component if needed
                      />
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Footer Color</Form.Label>
                    <Form.Group>
                      <ColorPickerInput
                        value={footerColor}
                        onChange={(color) => setFooterColor(color)}
                        errors={errors} // Pass errors to the component if needed
                      />
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    <Form.Label className="text-left">Image</Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        type="file"
                        {...register("image", {
                          // required: "Image is required",
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 1296 &&
                          //       sizes.height !== 465
                          //     ) {
                          //       return "Image width and height must be 1296 px and 465 px";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col className="main-form-section mt-3">
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("image") == "string" ? (
                      <div
                        className="image-preview-container mt-3"
                       
                      >
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                          
                        />
                      </div>
                    ) : (
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div
                          className="image-preview-container mt-3"
                         
                        >
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Preview"
                            className="image-preview"
                            
                          />
                        </div>
                      )
                    )}
                  </Row>
                </div>
              </Col> */}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
